import apiHandler from "middlewares/apiHandler";
import { ScenarioModel } from "pages/Dashboards/ScenarioView/data/ScenarioModel";
import { LocationScenarioSectionsModel } from "pages/Dashboards/ScenarioView/data/LocationScenarioSectionsModel";

/**
 * Fetches scenarios based on the locations's ID.
 * 
 * @param {number | undefined} locationId - The ID of the location.
 * @returns {Promise<Array<ScenarioModel>>} - A promise that resolves to an array of ScenarioModel objects.
 */
export const _getScenarioByLocationID = async (locationId: number | undefined) => {
  return apiHandler.get<Array<ScenarioModel>>(`Scenario/location/${locationId}`);
};

/**
 * Adds a new scenario.
 * 
 * @param {Array<ScenarioModel>} model - The model representing the new scenario.
 * @returns {Promise<Array<ScenarioModel>>} - A promise that resolves to the added ScenarioModel objects.
 */
export const _addScenario = async (model: Array<ScenarioModel>) => {
  return apiHandler.post<Array<ScenarioModel>>("Scenario", model);
};

/**
 * Fetches scenario sections for a list of location IDs.
 *
 * @param {number[]} locationIds - The list of location IDs.
 * @returns {Promise<Array<LocationScenarioSectionsModel>>} - A promise that resolves to an array of LocationScenarioSectionsModel objects.
 */
export const _getScenarioSectionsByLocationIds = async (locationIds: number[]) => {
  return apiHandler.post<Array<LocationScenarioSectionsModel>>("Scenario/sections", locationIds);
};